import * as React from 'react';

import {
  Alert,
  AlertDescription,
  AlertTitle,
  AlertVariant,
  Icon,
} from '@eluve/components';
import { SiteBannerTypesEnum } from '@eluve/graphql-types';

import { SiteBannerMarkdownContent } from './SiteBannerMarkdownContent';

type BannerTypeMapping = Record<SiteBannerTypesEnum, AlertVariant>;

const BannerTypeToAlertTypeMapping: BannerTypeMapping = {
  INFO: 'default',
  WARNING: 'warning',
  CRITICAL: 'destructive',
} as const;

export interface SiteBannerProps {
  bannerType: SiteBannerTypesEnum;
  title: string;
  message: string;
}

export const SiteBannerItem: React.FC<SiteBannerProps> = ({
  bannerType,
  title,
  message,
}) => (
  <Alert variant={BannerTypeToAlertTypeMapping[bannerType]}>
    <Icon name="AlertCircle" size="xs" />
    <AlertTitle>{title}</AlertTitle>
    <AlertDescription>
      <SiteBannerMarkdownContent message={message} />
    </AlertDescription>
  </Alert>
);
